/* eslint-disable no-param-reassign */
const SiscomexFormatsFilter = {
  install(Vue) {
    Vue.filter('SiscomexFormatsDIMaskFilter', (data) => {
      if (data) {
        data = data.toString().replace(/^(\d{2})(\d{7})(\d{1})/, '$1/$2-$3');
      }

      return data || '';
    });
    Vue.filter('SiscomexFormatsLIMaskFilter', (data) => {
      if (data !== undefined && data !== null) {
        data.toString().replace(/^(\d{2})(\d{7})(\d{1})/, '$1/$2-$3');
      }

      return data || '';
    });
  },
};

export default SiscomexFormatsFilter;
